import { render, staticRenderFns } from "./SpecialCase.vue?vue&type=template&id=d0980224&scoped=true&"
import script from "./SpecialCase.vue?vue&type=script&lang=js&"
export * from "./SpecialCase.vue?vue&type=script&lang=js&"
import style0 from "./SpecialCase.vue?vue&type=style&index=0&id=d0980224&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0980224",
  null
  
)

export default component.exports